import {Component, Input} from '@angular/core';
import {ClosableComponent} from "../../../../../models/closable.component";
import {BsModalRef} from "ngx-bootstrap";

@Component({
  selector: 'app-banner-translate-edit',
  templateUrl: './banner-translate-edit.component.html',
  styleUrls: ['./banner-translate-edit.component.scss']
})
export class BannerTranslateEditComponent extends ClosableComponent {
  @Input() text:string;
  @Input() isSmallText: boolean = true;
  @Input() titleTranslationKey: string = 'translation.banner.edit';
  @Input() inputTranslationKey: string = 'translation.banner.textTitle';

  constructor(bsModalRef: BsModalRef) {
    super(bsModalRef);
  }

  save() {
    this.closeWithResponse(this.text);
  }
}
